import { Directive, ElementRef, OnInit, Renderer2, Input, OnChanges, SimpleChanges, AfterViewInit, HostListener } from '@angular/core';

@Directive({
  selector: "[appTooltip]"
})
export class TooltipDirective implements OnChanges, OnInit, AfterViewInit {
  @Input() appTooltip: boolean;
  @Input() refEl: HTMLElement;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.appTooltip && !changes.appTooltip.firstChange) {
      if (
        changes.appTooltip.currentValue !== changes.appTooltip.previousValue
      ) {
        if (changes.appTooltip.currentValue) {
          this.show();
        } else {
          this.hide();
        }
      }
    }
  }

  ngOnInit() {
    this.hide();
  }

  ngAfterViewInit() {}

  private hide() {
    this.renderer.setStyle(this.el.nativeElement, "top", "0");
    this.renderer.setStyle(this.el.nativeElement, "left", "0");
    this.renderer.setStyle(this.el.nativeElement, "max-width", "100%");
    this.renderer.setStyle(this.el.nativeElement, "visibility", "hidden");
  }

  private show() {
    if (this.refEl) {
      const refElBounding = this.refEl.getBoundingClientRect();
      const tooltipMargin = (refElBounding.width * 20) / 100;
      this.renderer.setStyle(
        this.el.nativeElement,
        "max-width",
        refElBounding.width + tooltipMargin + "px"
      );
      let elBounding = this.el.nativeElement.getBoundingClientRect();
      this.renderer.setStyle(
        this.el.nativeElement,
        "top",
        refElBounding.top - (elBounding.height + 8) + "px"
      );
      this.renderer.setStyle(
        this.el.nativeElement,
        "left",
        refElBounding.left - tooltipMargin / 2 + "px"
      );
    }
    this.renderer.setStyle(this.el.nativeElement, "visibility", "visible");
  }
}
